import React, { useContext } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ThemeContext } from "../Theme";

import NavItem from "./NavItem";

import styles from "./ContentNavigation.scss";

export function ContentNavigation({ children }) {
  const theme = useContext(ThemeContext);
  const classes = classNames(styles.wrapper, { [styles[theme]]: theme });
  return (
    <div className={classes}>
      <div className={styles.navItems}>{children}</div>
    </div>
  );
}

ContentNavigation.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

ContentNavigation.Item = NavItem;

ContentNavigation.displayName = "ContentNavigation";

export default ContentNavigation;
